import { Dispatch, SetStateAction } from "react"
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { TestResultForm } from "../../types"

type TreatmentMethodField = {
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
}

const TreatmentMethodField = (props: TreatmentMethodField) => {
  const { formData, setFormData } = props

  const options = [
    'Adec ICX',
    'Crosstex Dentapure',
    'Crosstex Sterilex',
    'Citrisil Blue',
    'Citrisil White',
    'Sterisil Cartridge Inline',
    'Sterisil Cartridge Valved',
    'Sterisil System G4',
    'Sterisil System G5',
    'Sterisil System AC/AC+',
    'Sterisil Straw Distilled',
    'Sterisil Straw Municipal',
    'Other'
  ]

  const handleChange = (event: SelectChangeEvent<string>) => {
    const nextForm = structuredClone(formData)

    nextForm.product = event.target.value || null

    setFormData(nextForm)
  }

  const label = 'Daily Treatment Method *'
  const value = formData.product ?? ''
  const placeholder = 'Select a Treatment Method'

  return (
    <Box>
      <FormControl fullWidth size="small" sx={{ width: '100%' }}>
        <InputLabel>
          { label }
        </InputLabel>
        <Select
          value={value}
          label={label}
          onChange={(event) => handleChange(event)}
          placeholder={placeholder}
        >
          {
            options.map(option => {
              return (
                <MenuItem key={option} value={option}>
                  { option }
                </MenuItem>
              )
            })
          }
        </Select>
      </FormControl>
    </Box>
  )
}

export default TreatmentMethodField
